import { Navigate, Route, Routes } from 'react-router-dom';

import Error from '../modules/error/Index';

// auth
import AuthLayout from '../layouts/authLayout/Index';
import EmailVerification from '../modules/auth/pages/EmailVerification';
import ForgotPassword from '../modules/auth/pages/ForgotPassword';
import Login from '../modules/auth/pages/Login';
import OnBoarding from '../modules/auth/pages/OnBoarding';
import ResetPassword from '../modules/auth/pages/ResetPassword';
import VerifiyEmail from '../modules/auth/pages/VerifyEmail';
import VerifiyPage from '../modules/auth/pages/VerifyPage';

import Accounts from '../modules/auth/components/Accounts';
import Resend from '../modules/auth/components/Resend';
import SignUp from '../modules/auth/pages/SignUp';

// app
import AppLayout from '../layouts/appLayout/Index';

// integrations
import Integrations from '../modules/integrations/pages/Integrations';
import OAuthRelayPage from '../modules/integrations/components/OAuthRelayPage';
import BookingPage from '../modules/calendar/components/googleCalendar/BookingPage';

// campaign
import ContactApi from '../modules/campaign/components/ApiCampaign/ContactApi';
// import TaskRight from "../modules/Task/pages/TaskRightLayout";

// channels
import ListOfChannels from '../modules/channels/page/Channels';
import Whatsapp from '../modules/channels/page/whatsapp/Whatsapp';
import Facebook from '../modules/channels/page/facebook/index';

// messageTemplate
import CreateTemplateWA from '../modules/channels/components/templates/CreateTemplateWA';
import MessageTemplate from '../modules/channels/page/whatsapp/messageTemplate/MessageTemplate';
// import TemplateDetails from '../modules/channels/components/templates/TemplateDetails';
import TemplateDetails from '../modules/channels/page/whatsapp/TemplateDetails';

// phoneNumbers
import PhoneNumberss from '../modules/channels/page/whatsapp/phoneNumbers/Index';
// insights
import Insights from '../modules/channels/page/whatsapp/insights/Insights';
// payment configurations
import PaymentConfigurations from '../modules/channels/page/whatsapp/paymentConfigurations';

import BroadcastSetting from '../modules/campaign/components/BroadcastSetting/BroadcastSetting';
import SegmentList from '../modules/campaign/components/BroadcastSetting/BroadcastView/SegmentList';

// calendar
import Calendar from '../modules/calendar/pages/calendar';

//settings
import BrandSettings from '../modules/settings/pages/BrandSettings';
import Settings from '../modules/settings/pages/Settings';
import Keywords from '../modules/settings/pages/sequence/Keywords';
import ApiKeys from '../modules/settings/pages/apiKeys/ApiKeys';
import WhatsAppWidgetConfigurator from '../modules/settings/pages/Widget/WhatsAppWidgetConfigurator';

// inbox
import Homes from '../modules/chart/pages/Homes';
import Inbox from '../modules/inbox/pages/Inbox';
import WebChatInbox from '../modules/inbox/pages/Webchat';
// import WebChatChannel from "../modules/channels/page/webChat/Index";
import WebChat from '../modules/channels/page/webChat/Index';
import MyChannels from '../modules/channels/page/webChat/MyChannels';
import CreateNewChannel from '../modules/channels/page/webChat/CreateNewChannel';

// crm
import CrmHome from '../modules/crm/components/main';
import CrmSidebar from '../modules/crm/pages/CrmHome';
import SingleContact from '../modules/crm/pages/SingleContact';

// Account Settings
import BrandOverview from '../modules/accounts/components/BrandOverview';
import AccountsList from '../modules/accounts/pages/home/AccountsList';
import AccountUsers from '../modules/accounts/pages/home/AccountUsers';
import AccountsHome from '../modules/accounts/pages/home/Home';
import AccountsOverview from '../modules/accounts/pages/home/Overview';
import Purchases from '../modules/accounts/pages/home/Purchases';
import AccountsSettings from '../modules/accounts/pages/Settings';

// new campaigns
import CampaignsRoot from '../modules/campaigns/pages';
import Campaigns from '../modules/campaigns/pages/Campaigns';
import CampaignsList from '../modules/campaigns/pages/CampaignsList';
import Execution from '../modules/campaigns/pages/Execution';
import Overview from '../modules/campaigns/pages/Overview';
import Sequence from '../modules/campaigns/pages/Sequence';
import SequenceMetrix from '../modules/campaigns/pages/SequenceMetrix';
import SingleCampaign from '../modules/campaigns/pages/SingleCampaign';

import InvoiceDetails from '../modules/accounts/components/InvoiceDetails';
import InvoicePreview from '../modules/accounts/components/InvoicePreview';
import TemplatesList from '../modules/channels/components/whatsapp/TemplatesList';
import WhatsappBusinessInsights from '../modules/channels/page/whatsapp/WhatsappBusinessInsights';
import TemplateLibrary from '../modules/channels/page/whatsapp/WhatsappTemplateLibrary';
import WhatsappBusinessPhoneNumbers from '../modules/channels/page/whatsapp/whatsappBusinessPhoneNumbers';

// Data store
import DataSources from '../modules/corpus/pages/Index';

// Import the Products component if not already imported
import Products from '../modules/products/Products';
import ProductsList from '../modules/products/components/ProductsList/ProductsList';
import ProductDetails from '../modules/products/pages/ProductDetails';

import Flows from '../modules/channels/page/whatsapp/flows/';
import CreateFlow from '../modules/channels/page/whatsapp/flows/create';
import EditFlow from '../modules/channels/page/whatsapp/flows/edit';
import FlowInsights from '../modules/channels/page/whatsapp/flows/insights';

function Index() {
  const TOKEN = localStorage.getItem('authToken');

  return (
    <Routes>
      <Route path="*" element={<Navigate to={'/login'} />} />
      <Route path="/verify-email" element={<VerifiyEmail />} />
      <Route path="/invoice" element={<InvoiceDetails />} />
      <Route path="/invoice_preview" element={<InvoicePreview />} />
      <Route path="/404" element={<Error />} />
      <Route
        path="/user/integrations/oauth-callback"
        element={<OAuthRelayPage />}
      />
      <Route element={<AuthLayout />}>
        {/* <Route path='/stepper' element={<Stepper />} /> */}
        <Route path="/email-verfication" element={<EmailVerification />} />
        <Route path="/verify-page" element={<VerifiyPage />} />

        {/* self serve */}
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/on-boarding" element={<OnBoarding />} />

        <Route path="/resend" element={<Resend />} />

        <Route path="/login" element={<Login />} />
        <Route path="/Accounts" element={<Accounts />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
      </Route>
      <Route element={<AppLayout />}>
        {/* <Route path="/user/home" element={<Home />}></Route> */}
        <Route path="/user/home" element={<Homes />} />

        {/* Products Management */}
        <Route path="/user/products" element={<Products />}>
          <Route index element={<ProductsList />} />
          <Route path=":productId" element={<ProductDetails />} />
        </Route>

        <Route path="/user/calendar/" element={<Calendar />} />
        <Route path="/user/settings" element={<Settings />}>
          <Route index element={<Navigate to="keywords" replace />} />
          <Route path="keywords" element={<Keywords />} />
          <Route path="api-keys" element={<ApiKeys />} />
          <Route
            path="whatsapp-widget"
            element={<WhatsAppWidgetConfigurator />}
          />
        </Route>
        <Route path="/user/inbox" element={<Inbox />} />
        <Route path="/user/webchat" element={<WebChatInbox />} />

        {/* Integrations */}
        <Route path="/user/integrations">
          <Route index element={<Integrations />} />
        </Route>

        {/* channels */}
        <Route path="/user/channels" element={<ListOfChannels />}>
          <Route path="whatsapp" element={<Whatsapp />}>
            <Route path="phonenumbers" element={<PhoneNumberss />} />
            <Route
              path="business-phone-numbers"
              element={<WhatsappBusinessPhoneNumbers />}
            />
            <Route path="message-templates" element={<MessageTemplate />} />
            <Route path="flows">
              <Route index element={<Flows />} />
              <Route path="create-flow" element={<CreateFlow />} />
            </Route>
            {/* <Route path="create-flow" element={<CreateFlow />} /> */}
            <Route path="flows/:flowId/edit" element={<EditFlow />} />
            <Route path="flows/:flowId/insights" element={<FlowInsights />} />
            <Route path="templates" element={<TemplatesList />} />
            {/* <Route path="insights" element={<Insights />} /> */}
            <Route path="insights" element={<WhatsappBusinessInsights />} />
            <Route path="template-library" element={<TemplateLibrary />} />
            <Route
              path="payment-configurations"
              element={<PaymentConfigurations />}
            />
            {/* Template create, edit and duplicate */}
            <Route path=":template">
              <Route index element={<CreateTemplateWA />} />
              <Route path="template-details" element={<TemplateDetails />} />
            </Route>
            <Route
              path="*"
              element={<Navigate to="/user/channels/whatsapp/insights" />}
            />
          </Route>
          <Route path="facebook" element={<Facebook />}></Route>
          <Route path="webchat" element={<WebChat />}>
            <Route path="" element={<CreateNewChannel />} />
            <Route path="my-channels" element={<MyChannels />} />
            <Route path="my-channels/:channel" element={<MyChannels />} />
          </Route>
          <Route path="api-keys" element={<ApiKeys />}>
            <Route index element={<Navigate to="manage" />} />
            <Route path="manage" element={<ApiKeys />} />
          </Route>
        </Route>

        {/* CRM */}
        <Route path="/user/crm/" element={<CrmSidebar />}>
          <Route index element={<CrmHome />} />
          <Route path=":id" element={<SingleContact />} />
        </Route>

        {/* Account Details */}
        <Route path="/profile">
          <Route path="account" element={<AccountsHome />}>
            <Route path="overview" element={<AccountsOverview />}>
              <Route index element={<AccountsList />} />
              <Route path=":id">
                <Route path="brand_info" element={<BrandOverview />} />
                {/* <Route index element={<BrandsList />} />
                  <Route path="edit" element={<SingleAccountDetails />} />
                  <Route
                    path=":brand_id/edit"
                    element={<SingleBrandDetails />}
                  /> */}
              </Route>
            </Route>
            <Route path="purchases" element={<Purchases />} />
            <Route path="account_users" element={<AccountUsers />} />
          </Route>
          <Route path="settings" element={<AccountsSettings />} />
        </Route>

        {/* campaigns */}
        <Route path="/user/campaign" element={<CampaignsRoot />}>
          <Route path=":goalType" element={<Campaigns />}>
            <Route index element={<CampaignsList />} />
            {/* <Route path=":id" element={<Broadcast />} /> */}
            <Route path="settings/:id" element={<BroadcastSetting />} />
            <Route path="segment_list/:id" element={<SegmentList />} />
            <Route path=":id" element={<ContactApi />} />
          </Route>

          <Route path="view/:id" element={<SingleCampaign />}>
            <Route path="overview" element={<Overview />} />
            <Route path="execution" element={<Execution />} />
          </Route>
        </Route>

        <Route path="/user/campaign/:campaign_id/sequence/:sequence_id">
          <Route index element={<SequenceMetrix />} />
          <Route path="flow" element={<Sequence />} />
        </Route>

        <Route path="/user/data-sources">
          <Route index element={<DataSources />} />
        </Route>
        <Route path="/user/Agents">
          <Route index element={<div>Agents</div>} />
        </Route>
      </Route>
    </Routes>
  );
}

export default Index;
